export default __webpack_public_path__ + "static/media/downArrow-3.d4260968.svg";